


















































import { DataProxy } from 'apollo-cache';
import gql from 'graphql-tag';
import * as R from 'ramda';
import Vue from 'vue';

import { User } from '@/core/entity';
import { UserInput } from '@/core/interface';

import { listUserQL, userFragment } from './graphql';
import UserForm from './Form.vue';

export default Vue.extend({
  components: {
    'form-user': UserForm,
  },

  apollo: {
    users: {
      query: listUserQL,
      variables: { offset: 0, limit: 1000 },
      fetchPolicy: 'cache-first',
    },
  },

  data() {
    const userId = this.$route.params.user_id;
    return {
      isDrawerVisible: userId ? true : false,
      loading: false,
    };
  },

  computed: {
    userId(): string {
      return this.$route.params.user_id;
    },

    drawerTitle(): string {
      return this.userId ? 'Edit user' : 'Create a new user';
    },
  },

  watch: {
    userId(newVal: string | null) {
      this.isDrawerVisible = !!newVal;
    },
  },

  methods: {
    handleSave(val: any) {
      const { userId } = this;
      const input: UserInput = {
        name: val.name,
        email: val.email,
        country: val.country,
        roles: val.roles,
        avatar: val.file,
      };
      if (userId) {
        // update user
        this.$coreApp.user.update(
          this.userId,
          input,
          this.presenter('User updated.', 'Unable to update user:'),
          { name: 'ListUserPageUser', query: userFragment },
          this.updater,
        );
      } else {
        // create user
        this.$coreApp.user.create(
          input,
          this.presenter('User created.', 'Unable to create user:'),
          { name: 'ListUserPageUser', query: userFragment },
          this.updater,
        );
      }
    },

    hideDrawer() {
      this.isDrawerVisible = false;
      if (this.userId) {
        this.$router.back();
      }
    },

    presenter(success: string, failure: string) {
      return (err: Error | null, result: User | null, loading: boolean) => {
        this.loading = loading;
        if (err) {
          this.$message.error(`${failure} ${err.message}`);
        } else if (result !== null) {
          this.$message.success(success);

          this.hideDrawer();
        }
      };
    },

    showDrawer() {
      this.isDrawerVisible = true;
    },

    updater(
      store: DataProxy,
      res: {
        data: {
          newUser?: User;
          updateUser?: User;
        };
      },
    ) {
      const user = (res.data.newUser || res.data.updateUser) as User;

      const data: { users: User[] } | null = store.readQuery({
        query: listUserQL,
        variables: { offset: 0, limit: 1000 },
      });

      if (res.data.newUser) {
        // created
        data!.users = R.prepend(user, data!.users);
      } else if (res.data.updateUser) {
        // updated
        const idx = R.findIndex(R.propEq('id', user.id))(data!.users);
        if (idx === -1) {
          // tslint:disable-next-line no-console
          console.error('Unable to update user in Apollo cache.');
          return;
        }

        const previous = data!.users[idx];
        data!.users = R.update(
          idx,
          {
            ...previous,
            ...user,
          },
          data!.users,
        );
      }

      store.writeQuery({
        query: listUserQL,
        variables: { offset: 0, limit: 1000 },
        data,
      });
    },
  },
});
